import React from 'react';
import { FaCalendarTimes } from 'react-icons/fa';
import { NavLink, useLocation } from 'react-router-dom';
import { IoDocuments } from 'react-icons/io5';
import { BsFillCalendar2CheckFill, BsCalendarXFill } from 'react-icons/bs';
import { BiSolidCalendarEdit } from 'react-icons/bi';
import { TbCalendarRepeat } from 'react-icons/tb';
import './layout.css'; // Make sure this path is correct

const LeaveLayout = ({ children }) => {
  const location = useLocation();

  // Check if the current path is related to Leave Report
  const isLeaveReportActive = location.pathname.startsWith('/leave-report') || location.pathname.startsWith('/emps-leave-reports'); // Update condition to include /emps-leave-reports
  const isLeaveActive = location.pathname === '/leave'; // Check if we are on the /leave path

  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
        <FaCalendarTimes className="leave-policy-icon" />
        Leave Information
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="total-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/total-leave"
              >
                <BiSolidCalendarEdit className="nav-icon" /> Total Leave
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="pending-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/pending-leave"
              >
                <TbCalendarRepeat className="nav-icon" /> Pending Leave
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="approved-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/approved-leave"
              >
                <BsFillCalendar2CheckFill className="nav-icon" /> Approved Leave
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="rejected-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/rejected-leave"
              >
                <BsCalendarXFill className="nav-icon" /> Rejected Leave
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="report-leave-link"
                className={`nav-link ${isLeaveReportActive ? 'active' : ''}`}
                to="/leave-report"
              >
                <IoDocuments className="nav-icon" /> Leave Report
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="leave-link"
                className={`nav-link ${isLeaveActive ? 'active' : ''}`}
                to="/leave"
              >
                <IoDocuments className="nav-icon" /> Leave
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default LeaveLayout;
